import Vue from 'vue';
import Vuex from 'vuex';
import stocks from '@/store/stocks';
import districts from '@/store/districts';
import transactions from '@/store/transactions';
import calculator from '@/store/calculator';
import stocksAutocompleteSearch from '@/store/stocksAutocompleteSearch';
import transactionsAutocompleteSearch from '@/store/transactionsAutocompleteSearch';
import agents from '@/store/agents';

export default () => {
  Vue.use(Vuex);

  return new Vuex.Store({
    state: {},
    modules: {
      stocks,
      districts,
      transactions,
      calculator,
      stocksAutocompleteSearch,
      agents,
      transactionsAutocompleteSearch,
    },
  });
};
